import React from 'react';
import { IconProps } from './IconTypes';

const WorldLogo: React.FC<IconProps> = ({ 
  size = 16, 
  color = "currentColor",
  className = "",
  ...props 
}) => {
  return (
    <svg 
      width={size} 
      height={size}
      viewBox="0 0 100 100" 
      fill={color}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M51,8.5C28.1,8.5,9.5,27.1,9.5,50S28.1,91.5,51,91.5S92.5,72.9,92.5,50S73.9,8.5,51,8.5z M81.7,30.5l0.7-0.5  c1.5,2.3,2.7,4.8,3.7,7.4l-2.4,1.8c-0.9,0.7-2.2,0.1-2.3-1.1l-0.3-6.4C81.1,31.2,81.3,30.8,81.7,30.5z M27.3,71l-2.1,5.7  c-3.7-3.6-6.6-7.9-8.6-12.7l5.9-2.7c1-0.4,2.1,0,2.4,1l2.5,7.5C27.4,70.2,27.4,70.7,27.3,71z M67.5,62.4l-2.8,5.9  c-0.1,0.2-0.3,0.4-0.5,0.6l-2,1.3c-0.3,0.2-0.6,0.6-0.6,1l-2.4,15.1c-1.2,0.3-2.4,0.5-3.6,0.6L52,85.1c-0.4-0.2-0.7-0.6-0.8-1.1  L49,68.3c0-0.3-0.2-0.6-0.4-0.9l-6-5.6c-0.4-0.4-0.6-1.1-0.3-1.6l2.1-4.8c0.2-0.5,0.1-1.1-0.3-1.6l-8.6-9c-0.1-0.2-0.3-0.3-0.3-0.5  l-3.9-12c-0.2-0.6-0.7-1-1.3-1L24.8,31c-0.8,0-1.3-0.7-1.3-1.4c0-0.3,0.1-0.7,0.4-0.9l6.2-7.1c0.3-0.3,0.8-0.5,1.2-0.5l8,0.8  c0.2,0,0.3,0,0.5,0l16.2-3.7c1-0.2,1.9,0.6,1.7,1.6L57.5,21c0,0.3-0.2,0.6-0.4,0.8l-1.5,1.5c-0.6,0.6-0.6,1.5,0,2l4.1,4.1  c0.6,0.6,0.6,1.5,0,2L48,43.3c-0.3,0.3-0.4,0.6-0.4,1v6.3c0,0.7,0.5,1.3,1.2,1.4l13,2.5c0.3,0.1,0.6,0.2,0.8,0.5l4.8,6  C67.6,61.4,67.7,62,67.5,62.4z M74.4,22.7c0,0.7-0.4,1.4-1,1.7l-7.9,4.5c-1,0.6-2.4,0.1-2.8-1l-1-2.6c-0.4-0.9-0.3-2,0.2-2.8l2-3.7  c0.3-0.6,1-1,1.7-1h3.8c1.7,1,3.4,2.1,4.9,3.4V22.7z M84.8,64.1L75.4,58c-0.6-0.4-0.8-1.1-0.6-1.7l3.2-8.9c0.1-0.3,0.3-0.5,0.6-0.7  l8.5-5.7c0.7,2.9,1.1,5.9,1.1,8.9c0,5.2-1.1,10.1-3,14.6C85.1,64.4,85,64.2,84.8,64.1z" 
        transform="translate(-5,-5) scale(1.05,1.05)" />
    </svg>
  );
};

export default WorldLogo;